module.exports = __webpack_public_path__ + "static/media/arrow_down_circle.3fdbc2f4.svg";